import styled from 'styled-components';
import { Colors, Col, Text } from 'basic-ui-lib';
import { IcTime } from 'basic-ui-lib/icons';

const MOCK_CONNECTED_TIME = '0d 0h 0m';

const ConnectedTimeCard = () => {
  return (
    <Card>
      <Col gap={4} flex={1}>
        <Text caption_2 color="neutral.text.1">
          Total Connected Time
        </Text>
        <Text title_h5 semibold color="neutral.text.1">
          {MOCK_CONNECTED_TIME}
        </Text>
      </Col>
      <TimeIconWrapper>
        <IcTime width={24} height={24} fill={Colors.neutral.bg[1]} />
      </TimeIconWrapper>
    </Card>
  );
};

export default ConnectedTimeCard;

const Card = styled.div`
  display: flex;
  align-items: center;
  background: ${Colors.gradient.connectedTime};
  border-radius: 8px;
  padding: 16px;
  gap: 8px;
`;

const TimeIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
